import { __extends } from "tslib";
import React from 'react';
import { FaChevronDown } from 'react-icons/fa';
;
var AccordionPanel = /** @class */ (function (_super) {
    __extends(AccordionPanel, _super);
    function AccordionPanel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.accordionPanelRef = React.createRef();
        _this.state = {
            open: true,
            stateClass: '',
            accordionStyle: {
                height: 0
            }
        };
        _this.handleClick = function () {
            var height = 0;
            if (_this.accordionPanelRef.current) {
                height = _this.accordionPanelRef.current.scrollHeight;
            }
            //height = height > 280 ? 280 : height;
            if (_this.state.open) {
                _this.setState({
                    open: false,
                    stateClass: '',
                    accordionStyle: {
                        height: 0
                    }
                });
            }
            else {
                _this.setState({
                    open: true,
                    stateClass: 'm-accordion-panel--open',
                    accordionStyle: {
                        height: height
                    }
                });
            }
        };
        return _this;
    }
    AccordionPanel.prototype.componentDidMount = function () {
        this.setState({ open: this.props.defaultClosed });
    };
    AccordionPanel.prototype.componentDidUpdate = function (prevProps) {
        var _this = this;
        this.updateHeight(prevProps.children);
        if (prevProps.defaultClosed !== this.props.defaultClosed) {
            // console.log(this.props.defaultClosed, this.props.heading, 'change it')
            this.setState({ open: this.props.defaultClosed }, function () {
                if (!_this.props.defaultClosed) {
                    _this.setState({
                        accordionStyle: {
                            height: 0
                        }
                    });
                }
                else {
                    _this.updateHeight(prevProps.children);
                }
            });
        }
        else {
            if (!this.state.open && this.state.accordionStyle.height !== 0) {
                this.setState({
                    accordionStyle: {
                        height: 0
                    }
                });
            }
        }
    };
    AccordionPanel.prototype.updateHeight = function (children) {
        if (children !== this.props.children && this.state.open && this.accordionPanelRef.current) {
            var nextHeight = this.accordionPanelRef.current.scrollHeight;
            if (nextHeight === this.state.accordionStyle.height) {
                return;
            }
            this.setState({
                accordionStyle: {
                    height: nextHeight
                }
            });
        }
    };
    AccordionPanel.prototype.render = function () {
        return (React.createElement("div", { className: "m-accordion-panel" + (this.state.open ? " m-accordion-panel--open" : "") },
            React.createElement("div", { className: "m-accordion-panel__header", onClick: this.handleClick },
                React.createElement("div", { className: "m-accordion-panel__heading" }, this.props.heading),
                React.createElement("div", { className: "m-accordion-panel__state-indicator" },
                    React.createElement(FaChevronDown, null))),
            React.createElement("div", { ref: this.accordionPanelRef, className: "m-accordion-panel__content", style: this.state.accordionStyle }, this.props.children)));
    };
    return AccordionPanel;
}(React.Component));
export { AccordionPanel };
//# sourceMappingURL=AccordionPanel.js.map